// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Wl-z","tupacHeader":"Xl-z","tupacHeader2":"Yl-z","tupacMenu":"Zl-z","tupacMenu2":"_l-z","tupacMain":"am-z","tupacMain2":"bm-z"};